import { post, get, baseURL } from "@/utils/request";

// Get Channels list'
export const getChannels = (params: any) => post(`/paymentChannel/list`, params);

// Deposit
export const withdraw = (params: any) => post(`/withdraw`, params);

export const withdrawSettingByUserID = (params: any) => post(`/withdrawSettings/getByUserID`, params);

export const addWithdrawSettings = (params: any) => post(`/withdrawSettings/addWithdrawSettings`, params);

export const getAddressBook = (params: any) => post(`/CoinWithdrawAddr/addressBook`, params);

export const getNetworkOptions = (params: any) => post(`/paymentChannel/getNetworkOptions?lang=${localStorage.getItem('lang')}`, params);

export const withdrawAddressOperations = (params: any) => post(`/CoinWithdrawAddr/withdrawAddressOperations`, params);